/* Package JSON Import will be here */
import React, { Component } from 'react';
/* Package JSON Import will be here */

/* Project Import will be here */
import readScreenContainer from './read.container';
/* Project Import will be here */

export default class ReadScreen extends Component {

    render() {
        const WrappedReadScreen = readScreenContainer;

        return (
            <WrappedReadScreen />
        );
    }
}

ReadScreen.displayName = 'ReadScreen';